// Dependencies
import React, { useEffect, useMemo, useState } from "react";

// Modules

// App
import { apiEndpoints } from "../../config";

import PostEdit from "../../partials/posts/postEdit";

export default function TrainingEdit() {
  const [editorContent, setEditorContent] = useState(null);
  const [post, setPost] = useState(null);

  useEffect(() => {
    if (post !== null && editorContent === null) {
      setEditorContent(post.body);
    }

  }, [post, editorContent]);

  const extraFields = useMemo(() => {
    if (editorContent) {
      const trainingBlocks = editorContent.blocks.filter(
        (block) => block.type === "trainingSection",
      );
      const entitySelection = trainingBlocks.flatMap((block) =>
        block.data.entities.map((entity) => ({
          id: entity.id,
          bundle: entity.bundle,
        })),
      );
      return { field_references: entitySelection };
    }
  }, [editorContent]);

  return (
    <PostEdit
      entityType={"training"}
      apiEndpoint={apiEndpoints.training}
      screenClassName={"training"}
      categoryTitle={"Training category"}
      categoryName={"field_training_category"}
      targetVid={"training_categories"}
      returnRoute={"/training-creator"}
      backBtnText={"Training Library"}
      previewRoute={"/training/preview"}
      logCustomEventType={"Course"}
      extraFields={extraFields}
      featuredImageEnabled={true}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
      setEntityEditorContent={(body) => {
        setEditorContent(body);
      }}
      editorProps={{
        title: true,
        subtitle: true,
        summary: true,
        body: true,
        list: true,
        table: true,
        image: true,
        video: true,
        embed: true,
        rule: true,
        buttonGroup: true,
        chart: true,
        map: true,
        trainingSection: true,
      }}
      disableReactions={true}
      disableComments={true}
      setEditorContent={setEditorContent}
      imageBlockEnabled={true}
    ></PostEdit>
  );
}
